
import { Component, HostListener, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { EstadoDescargaCertificadoStepperService } from '../../services/estado-descarga-certificado-stepper.service';
import { BASIC_CLIENT_INFO } from '@constants/data-service.constant';
import { StorageService } from '@services/storage/storage.service';
import { loadRemoteModule } from '@angular-architects/module-federation';
import { environment } from 'src/environments/environment';
import * as date from 'date-fns-tz';
import { CertificadoSaldosService } from '../../services/certificado-saldos.service';
import { Util } from '@shared/common/utils/util';
import { ModalService } from '@services/modal/modal.service';
import { Router } from '@angular/router';
import { DATA_UPDATE, HOME_URL, PROFILE } from '@constants/url.constant';
import { GenericErrorOps } from '@shared/components/generic-error/interfaces/generic-error-ops.interface';
import { CONFIRM_SOLICITUD_ERROR } from '@constants/congelamiento-saldo';
@Component({
  selector: 'app-modal-descarga-certificado',
  templateUrl: './modal-descarga-certificado.component.html',
  styleUrls: ['./modal-descarga-certificado.component.scss'],
  standalone: false
})

export class ModalDescargaCertificadoComponent implements OnInit, OnDestroy {
  pasos = [
    { id: 1, titulo: 'Declaración y consideraciones', subtitulo: 'Información de ahorros' },
    { id: 2, titulo: 'Validación', subtitulo: 'Claves' },
    { id: 3, titulo: 'Descarga', subtitulo: 'Certificado de saldos' },
    { id: 4, titulo: 'Confirmación de descarga', subtitulo: 'Certificado obtenido' },
  ];

  datosPersonales = { telefono: '+56 9 1234 5678', email: 'prueba@example.com' };

  pasoActual = 1;
  aceptaDeclaracion = false;
  isResponsive: boolean = false;
  @Input() certificadoData: any = null;
  @Input() esCopiaCertificado: boolean = false;
  @ViewChild('microfrontContainer', { read: ViewContainerRef }) microfrontContainer!: ViewContainerRef;
  tipoValidacionSeguridad: string | null = null;
  fechaDescargaCertificado: Date = date.zonedTimeToUtc(new Date(), 'America/Santiago');
  loading = false;
  errorServiceDescargaCertificado = false;
  public errorOps: GenericErrorOps;
  attempt: boolean = false;
  nAttempts: number = 0;

  constructor(private readonly modalCtrl: ModalController, private readonly descargaCertificadoStepper: EstadoDescargaCertificadoStepperService, private readonly storageService: StorageService,
    private readonly certificadoSaldosService: CertificadoSaldosService,
    private readonly util: Util,
    private readonly modalService: ModalService,
    private readonly router: Router,
  ) {

    this.descargaCertificadoStepper.setStepCurrent(1);
    this.isResponsive = window.innerWidth < 840;
  }

  async ngOnInit() {

    this.errorOps = CONFIRM_SOLICITUD_ERROR;

    globalThis.addEventListener('microfront:validacionExitosa', this.onValidacionExitosa.bind(this));
    globalThis.addEventListener('microfront:closeAllModals', this.onCerrar.bind(this));

    const infoClient = await this.storageService.get(BASIC_CLIENT_INFO);
    this.datosPersonales = { telefono: infoClient.cellphoneNumber, email: infoClient.email };

    this.tipoValidacionSeguridad = await this.storageService.get('tipoValidacionSeguridad');

    if (this.pasoActual === 2) {
      await this.cargarMicrofront();
    }

    this.validaSiEsCopiaCertificado();
  }

  private validaSiEsCopiaCertificado(): void {
    this.aceptaDeclaracion = this.esCopiaCertificado;
  }

  ngOnDestroy() {
    globalThis.removeEventListener('microfront:validacionExitosa', this.onValidacionExitosa.bind(this));
    globalThis.removeEventListener('microfront:closeAllModals', this.onCerrar.bind(this));
  }

  private onValidacionExitosa() {
    this.pasoActual = 3;
    this.descargaCertificadoStepper.setStepCurrent(this.pasoActual);
  }

  private async onCerrar() {
    let modal = await this.modalCtrl.getTop();
    while (modal) {
      await this.modalCtrl.dismiss();
      modal = await this.modalCtrl.getTop();
    }
  }
  cerrar() {
    if (!this.esCopiaCertificado && this.pasoActual !== 4) {
      this.modalSalirSinDescargar();
    }
    else {
      sessionStorage.removeItem('microfront_embebido');
      this.modalCtrl.dismiss();
    }
  }

  private modalSalirSinDescargar(tipoElemento: string = '') {
    const dataModal = {
      logo: '../assets/icons/error_32px.svg',
      title: '¿Deseas salir sin descargar el certificado?',
      subtitle: 'Al salir deberás comenzar de nuevo para obtener el Certificado de Saldos.',
      primaryButtonText: 'Salir',
      secondaryButtonText: 'Continuar descarga',
      primaryButtonCallback: () => {
        sessionStorage.removeItem('microfront_embebido');
        void this.onCerrar();
        if (tipoElemento === 'link') {
          this.router.navigate([DATA_UPDATE, HOME_URL, PROFILE]);
        }
      },
      secondaryButtonCallback: () => this.modalService.closeModal(),
      closeButtonCallback: () => { },
    }
    void this.modalService.openGenericModalWithSubtitle(dataModal);
  }

  async avanzar() {
    if (this.pasoActual < this.pasos.length) {
      this.pasoActual++;
      this.descargaCertificadoStepper.setStepCurrent(this.pasoActual);
      if (this.pasoActual !== 1) {
        this.aceptaDeclaracion = false;
      }
      if (this.pasoActual === 2) {
        setTimeout(() => this.cargarMicrofront(), 0); // espera al render
      }
    } else {
      sessionStorage.removeItem('microfront_embebido');
      this.modalCtrl.dismiss({ confirmado: true });
    }
  }

  irAlPaso(paso: number) {
    this.pasoActual = paso;
  }

  @HostListener("window:resize", ["$event"])
  onWindowResize() {
    this.isResponsive = globalThis.innerWidth < 840;
  }

  keyPressClose(event: KeyboardEvent) {
    if (event.key === ' ' || event.key === 'Enter') {
      this.cerrar();
    }
  }

  async cargarMicrofront() {
    if (!this.microfrontContainer) return;

    sessionStorage.setItem('microfront_embebido', 'true');
    this.microfrontContainer.clear();

    try {
      const { KeyOptionsOverpaymentComponent } = await loadRemoteModule({
        type: 'module',
        remoteEntry: environment.SECURITY_REMOTE_ENTRY_URL,
        exposedModule: './VALIDACION_COMPONENT',
      });

      this.microfrontContainer.createComponent(KeyOptionsOverpaymentComponent);
    } catch (error) {
      console.error('Error al cargar el microfront remoto:', error);
    }
  }


  public async descargarCertificado() {
    this.loading = true;
    try {
      const token = await this.util.getIdToken();
      await this.certificadoSaldosService.descargarCertificadosUnificados(token);
      this.pasoActual = 4;
      this.descargaCertificadoStepper.setStepCurrent(this.pasoActual + 1);
      this.loading = false;
      this.errorServiceDescargaCertificado = false;
    } catch (error) {
      this.errorServiceDescargaCertificado = true;
      this.loading = false;
      this.attempt = false;
      if (this.nAttempts === 3)
        await this.onGoToInicioTramite()
      console.error('Error al descargar certificado:', error);
    }
  }

  public goToPerfil() {
    if (!this.esCopiaCertificado && this.pasoActual !== 4) {
      this.modalSalirSinDescargar('link');
    }
    else
      this.router.navigate([DATA_UPDATE, HOME_URL, PROFILE]);
  }

  async reintentarErrorDescarga() {
    this.attempt = true;
    this.nAttempts++;
    console.log(this.nAttempts)
    if (this.nAttempts <= 3) await this.descargarCertificado();
  }

  async onGoToInicioTramite() {
    this.validaSiEsCopiaCertificado();
    this.pasoActual = 1;
    this.descargaCertificadoStepper.setStepCurrent(this.pasoActual);
  }
}